import { ReactNode } from 'react';
import CardsContainer from '../CardsContainer';

export function BlogCardContainer({ children }: { children: ReactNode }) {
	return <CardsContainer columns={2}>{children}</CardsContainer>;
}
